/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12a.75.75 0 0 1 1.5 0c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0a.75.75 0 0 1 0 1.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.0354 6.904A6.4725 6.4725 0 0 0 12 5.5c-3.5899 0-6.5 2.9101-6.5 6.5s2.9101 6.5 6.5 6.5 6.5-2.9101 6.5-6.5a6.4725 6.4725 0 0 0-1.404-4.0354l5.404-5.404V6.75a.75.75 0 0 0 1.5 0V0h-6.75a.75.75 0 0 0 0 1.5h4.1893l-5.4039 5.404ZM12 7c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5 5-2.2386 5-5a4.9778 4.9778 0 0 0-.9739-2.9654l-3.2458 3.2457a.75.75 0 0 1-1.0606 0 .75.75 0 0 1 0-1.0606l3.2457-3.2458A4.9775 4.9775 0 0 0 12 7Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuExternalCI'
);
